<template>
  <li class="component-profitItem">
    <div class="content-wrap">
      <!-- <div class="item-wrap mobile">账号{{ item.mobile }}</div> -->
      <div class="item-wrap"><span class="label">下单时间:</span>{{ getTimeStr(item.crtTime) }}</div>
      <div class="item-wrap"><span class="label">订单编号:</span>{{ item.orderCode }}</div>
      <div class="item-wrap enrolledTime" v-if="item.enrolledTime"><span class="label">入账时间:</span>{{ getTimeStr(item.enrolledTime) }}</div>
    </div>
    <div class="bean-num" v-if="isBean">{{ item.num }}<img class="bean-img" :src="beanIcon" /></div>
    <div class="bean-num" v-else>¥{{ item.money }}</div>
  </li>
</template>

<script>
export default {
  name: 'profitItem',
  props: {
    isBean: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: function() {
        return {
          orderCode: '',
          mobile: '',
          num: 0,
          money: 0,
          crtTime: '',
          enrolledTime: '',
        }
      },
    },
  },
  data() {
    return {
      beanIcon: require('../assets/images/icon_bean.png'),
    }
  },
  methods: {
    getTimeStr(time) {
      if (time.length === 19) {
        return time.substring(0, 16)
      }
      return time
    },
  },
}
</script>

<style type="text/css" lang="scss" scoped>
.component-profitItem {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #eeefef;
  padding: 0.2rem 0;
  .content-wrap {
    flex: 1;
    margin-right: 0.2rem;
    min-width: 0; // 解决flex遇上white-space: nowrap引起样式冲突
    .item-wrap {
      margin-bottom: 0.2rem;
      color: #999;
      font-size: 0.26rem;
      &:last-child {
        margin-bottom: 0;
      }
      &.mobile {
        margin-top: 0;
        font-size: 0.28rem;
        color: #414154;
        font-weight: 500;
      }
      &.enrolledTime {
        color: #6e82d7;
      }
      .label {
        margin-right: 0.04rem;
        color: #999;
      }
    }
  }
  .bean-num {
    display: flex;
    align-items: center;
    color: #e93b3d;
    font-weight: bold;
    font-size: 0.32rem;
    .bean-img {
      height: 0.36rem;
    }
  }
}
</style>
